import { Button, useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import clsx from 'clsx';
import { useAppDispatch } from 'shared/hooks';
import { setVisible } from 'shared/slices';

interface IActionLinkButtonProps {
  children: string;
}

export const ActionButton: React.FC<IActionLinkButtonProps> = ({ children }) => {
  const device = useDeviceType();
  const dispatch = useAppDispatch();

  const size = device === 'phone' ? 'M' : 'L';

  const handleModalOpen = () => {
    dispatch(setVisible(true));
  };

  return (
    <div className={clsx(styles['wrapper'], styles[device])}>
      <Button fullWidth size={size} onClick={handleModalOpen}>
        {children}
      </Button>
    </div>
  );
};
